









































import { defineComponent } from '@vue/composition-api';

import Dropzone from '@/components/Dropzone.vue';
import useFiles from '@/use/useFiles';
import useRouter from '@/use/useRouter';

const List = defineComponent({
  setup() {
    const { importFile, list, refreshList } = useFiles();
    const { router } = useRouter();

    async function fileAdd(file: File) {
      const newFileName = await importFile(file);
      console.log(newFileName);
      console.log(list.value);
    }

    function deleteFile(filename: string) {
      console.log(filename);
      localStorage.removeItem(`utranslate-file-${filename}`);
      localStorage.removeItem(`utranslate-json-${filename}`);
      localStorage.removeItem(`utranslate-companion-${filename}`);
      refreshList();
      router.replace({ name: 'List' });
    }

    return {
      fileAdd,
      list,
      deleteFile,
    };
  },
  components: {
    Dropzone,
  },
});

export default List;
